import { message } from "antd";
import React, { ReactNode } from "react";

type MessageType = "success" | "info" | "warning" | "error" | "loading";

let messageApiInstance: ReturnType<typeof message.useMessage>[0] | null = null;

/**
 * Set the message API instance from `message.useMessage()` for contextual usage.
 */
export const setMessageApi = (
  api: ReturnType<typeof message.useMessage>[0]
) => {
  messageApiInstance = api;
};

/**
 * Globally configure Ant Design message settings.
 */
export const configureMessage = (options: {
  top?: number;
  duration?: number;
  maxCount?: number;
  rtl?: boolean;
  prefixCls?: string;
}) => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    message.config(options);
  }
};

/**
 * Show a styled message with optional custom icon.
 * Note: We omit `type` so that custom icon is preserved.
 */
export const showMessage = (
  _type: MessageType,
  content: string,
  duration: number = 3,
  className?: string,
  icon?: ReactNode
) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    console.log(`[MESSAGE] ${_type.toUpperCase()}: ${content}`);
    return;
  }

  // Destroy all existing messages before showing a new one
  message.destroy();

  if (messageApiInstance) {
    messageApiInstance.open({
      content,
      duration,
      className,
      icon,
    });
  } else {
    message[_type](content, duration);
  }
};
